module.exports = __webpack_public_path__ + "5413aa0f78ed82dc50daf0d7087d9154.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-17.png
// module id = 2076
// module chunks = 0